module.exports = __webpack_public_path__ + "static/img/3化工.a094c762.jpg";